import React from 'react';

const FiltersContext = React.createContext({
  familyType: 'All',
  setFamilyType: (value) => { },
  settingType: 'All',
  setSettingType: (value) => { },
  childAge: 'All',
  setChildAge: (value) => { },
  childRace: 'All',
  setChildRace: (value) => { },
  acceptSubsidies: '',
  setAcceptSubsidies: (value) => { },
  qualityRating: '',
  setQualityRating: (value) => { },
  displayBy: '',
  setDisplayBy: (value) => { },
});

export default FiltersContext;
